import React from 'react'
import classes from '../styles.module.scss'
import { useTranslation } from 'react-i18next'
import { sections } from '../../../consts/navigation.conts';
import { useNavigate } from 'react-router-dom';
import { oblast } from '../../../consts/kato.conts';
import { NavLink } from 'react-router-dom';
import { useKato } from '../../../contexts/kato.context';
import { statisticsKeys } from '../../../consts/other.conts';
import { Logo } from '../../../assets/icons';

const baseClass = 'left-menu';
const translationKey = `admin`;

const LeftMenu = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const { statistics } = useKato();

    return (
        <div className={classes[baseClass]}>
            <div className={classes[`${baseClass}__logo`]} onClick={() => navigate('/')}>
                <Logo />
            </div>

            <div className={classes[`${baseClass}__sections`]}>
                {sections.map((section) => (
                    <NavLink
                        to={`/admin/${section}`}
                        key={section}
                        className={({ isActive }) => isActive || true
                            ? `${classes[`${baseClass}__section`]} ${classes[`${baseClass}__section--active`]}`
                            : classes[`${baseClass}__section`]}
                    >
                        {t(`${translationKey}.${section}`)}
                    </NavLink>
                ))}

                <div onClick={() => navigate('/')} className={classes[`${baseClass}__section`]}>
                    {t(`actions.logout`)}
                </div>
            </div>

            {statistics && (
                <div className={classes[`${baseClass}__statistics`]}>
                    {statisticsKeys.map((key) => (
                        <div className={classes[`${baseClass}__statistics__item`]} key={key}>{t(`${translationKey}.${key}`)}: {statistics[oblast.kato]?.[key]}</div>
                    ))}
                </div>
            )}

        </div>
    )
}

export default LeftMenu